'use client'

import { reloadPage } from '@marketplace-web/shared/browser'
import { confirmCancellationAgreement } from '@marketplace-web/domain/conversation-shipping-data'
import { ResponseCode } from 'data/api/response-codes'

import {
  ConversationActionButton,
  ConversationActionProps,
} from '@marketplace-web/domain/conversation-action'
import { useConversationContext } from '@marketplace-web/domain/core-conversation'

type Props = ConversationActionProps

const CancellationConfirm = ({ title, primary, size, theme, inverse }: Props) => {
  const { conversation } = useConversationContext()

  const transactionId = conversation?.transaction?.id

  async function confirmAgreement() {
    if (!transactionId) return

    const response = await confirmCancellationAgreement(transactionId)

    if (response.code === ResponseCode.Ok) reloadPage()
  }

  if (!transactionId) return null

  return (
    <ConversationActionButton
      text={title}
      primary={primary}
      size={size}
      theme={theme}
      inverse={inverse}
      onClick={confirmAgreement}
    />
  )
}

export default CancellationConfirm
